var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeartLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.629,
    height: 25.29,
    viewBox: "0 0 28.629 25.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.05,5.762a6.875,6.875,0,0,0-9.725,0L15,7.088,13.675,5.762A6.877,6.877,0,1,0,3.95,15.488l1.325,1.325L15,26.538l9.725-9.725,1.325-1.325A6.875,6.875,0,0,0,26.05,5.762Z",
    transform: "translate(-0.686 -2.498)",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartLight);
export default __webpack_public_path__ + "static/media/icon-heart-light.a4cfcc98535441d2146801d66f82d597.svg";
export { ForwardRef as ReactComponent };